import * as React from 'react';
import { forwardRef, useMemo } from 'react';

import TextField, { TextFieldProps } from '../text-field';
import { detectIsEmail } from '../../utils/validation';
import { withFormTextField } from '../form';
import { ValidationRule, getValueByName } from '../form/shared';


export type EmailTextFieldProps = {
	enableOnChangeValidation?: boolean;
} & TextFieldProps;

const EmailTextField: React.FC<EmailTextFieldProps> = forwardRef((props, ref) => {
	const {
		value,
		enableOnChangeValidation,
		...rest
	} = props;
	const isValid = enableOnChangeValidation && value
		? detectIsEmail(value.toString())
		: true;
	const hasError = !isValid;

	return (
		<TextField
			ref={ref as React.Ref<any>}
			value={value}
			label='E-mail'
			placeholder='Например, mail@example.com'
			error={hasError}
			helperText={hasError ? 'Некорректный E-mail' : ''}
			{...rest}
		/>
	);
});

EmailTextField.displayName = 'EmailTextField';
EmailTextField.defaultProps = {};

const FormEmailTextFiledBase = withFormTextField<Omit<React.ComponentProps<typeof EmailTextField>, 'name'>, any>(EmailTextField);
const FormEmailTextFiled: React.FC<React.ComponentProps<typeof FormEmailTextFiledBase>> = props => {
	const { name } = props;
	const validationRules: Array<ValidationRule> = useMemo(() => ([{
		errorText: 'Некорректный e-mail',
		fn: (formObject) => {
			const value = getValueByName(name, formObject);
			const isValid = value
				? detectIsEmail(value.toString())
				: true;

			return isValid;
		},
	}]), []);

	return (
		<FormEmailTextFiledBase
			{...props}
			validationRules={validationRules}
		/>
	);
};

export { FormEmailTextFiled };
export default EmailTextField;
